import { useEffect, useState } from 'react';

import { TextAreaInput } from '@hivebrite/design-system/Inputs';

import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { TextItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/textItemAttributes';

const Content = ({
  item,
  onChange,
}: ComponentSettingsTab<TextItemAttributes>) => {
  const [value, setValue] = useState(item.content);

  const handleChange = (e) => {
    const newValue = e.target.value || '';

    setValue(newValue);

    onChange({
      id: item.id,
      settingKey: 'content',
      value: newValue,
    });
  };

  useEffect(() => {
    if (item.content !== value) {
      setValue(item.content);
    }
  }, [item.content]);

  return (
    <AccordionTitle isInitiallyOpen title={__('Text')}>
      <TextAreaInput
        dataTestId="textSettingsContent"
        id="textSettingsContent"
        minHeight={400}
        name="textSettingsContent"
        onChange={handleChange}
        value={value}
      />
    </AccordionTitle>
  );
};

export default Content;
